module.exports = __webpack_public_path__ + "img/automotive-light.4e5bbac5.webp";